import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, IconButton } from '@tb/ui';
import { useT } from '../i18n/LocaleProvider';
import { setBackButton } from '../telegram/telegram';

export interface ScreenProps {
  title?: string;
  back?: string | (() => void);
  action?: ReactNode;
  children: ReactNode;
}

export function Screen({ title, back, action, children }: ScreenProps) {
  const navigate = useNavigate();
  const t = useT();

  useEffect(() => {
    if (!back) return setBackButton(null);
    const handler = typeof back === 'function' ? back : () => void navigate(back);
    return setBackButton(handler);
  }, [back, navigate]);

  const onBack = () => {
    if (typeof back === 'function') back();
    else if (back) void navigate(back);
  };

  return (
    <>
      <header className="app-header">
        {back ? (
          <IconButton icon="back" label={t('common.back')} onClick={onBack} />
        ) : (
          <Icon name="ton" size={22} />
        )}
        <span className="app-header__title tb-grow tb-truncate">{title ?? 'TON Builder'}</span>
        {action}
      </header>
      <main className="app-main">{children}</main>
    </>
  );
}
